/* eslint-disable no-shadow */
/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
import { Box, TableCell, TableRow } from "@mui/material";
import React, { useEffect, useState } from "react";
import moment from "moment";
import Button from "../../../../components/common/Button";
import Pagination from "../../../../components/common/new/Pagination/Pagination";
import {
  Constants,
  GOHONZON_TRANSACTION_TYPE_OPTIONS,
  GOHONZON_OPTIONS,
} from "../../../../contants";
import { GOHONZON_HANDOVER_INVENTORY_COL } from "../../../../contants/table/gohonzonSearch";
import tableStyle from "../../../../theme/styles/table";
import style from "./GohonzonTable.styles";
import Table from "../../../../components/common/new/Table/Table";
import Toast from "../../../../components/common/Toast";
import Dropdown from "../../../../components/common/new/Dropdown/Dropdown";
import Gohonzon from "../../../../services/api/gohonzon";
import { getGohonzonType } from "../../../../utils";
import { performOperation } from "../../../member/MemberSearch/utils";
import Loader from "../../../../components/common/Loader/Loader";

const getRows = (searchData) =>
  searchData.map((gohonzon) => (
    <TableRow style={tableStyle.tableRow}>
      <TableCell>
        {gohonzon.dateOfReceivingGohonzon !== null
          ? moment(gohonzon.dateOfReceivingGohonzon).format(" DD/MM/YYYY")
          : "NA"}
      </TableCell>
      <TableCell>{getGohonzonType(gohonzon.gohonzonType)}</TableCell>
      <TableCell>{gohonzon.updateType.replace(/_/g, " ") || "NA"}</TableCell>
      <TableCell>{gohonzon.batchNumber || "NA"} </TableCell>
      <TableCell>
        {gohonzon.handoverMemberId ? (
          <span>
            {gohonzon.handoverTo} (ID:{gohonzon.handoverMemberId})
          </span>
        ) : (
          "NA"
        )}
      </TableCell>
      <TableCell>
        {[
          gohonzon?.areaName,
          gohonzon?.clusterName,
          gohonzon?.zoneName,
          gohonzon?.regionName,
          gohonzon?.chapterName,
          gohonzon?.districtName,
          gohonzon?.blockName,
        ]
          .filter(Boolean)
          .join("/ ") || "NA"}{" "}
      </TableCell>
      <TableCell>{gohonzon.status || "NA"} </TableCell>
    </TableRow>
  ));

function HandoverInventory() {
  const [showToast, setShowToast] = useState(null);
  const [searchData, setSearchData] = useState([]);
  const [selectedGohonzonType, setSelectedGohonzonType] = useState("");
  const [selectedTransactionType, setSelectedTransactionType] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [size, setSize] = useState(Constants.DEFAULT_PAGE_SIZE);
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = async (page = 0, size = Constants.DEFAULT_PAGE_SIZE) => {
    try {
      setIsLoading(true);
      const data = {
        gohonzonType: selectedGohonzonType,
        updateType: selectedTransactionType,
        page,
        size,
      };
      const result = await Gohonzon.getGohonzonMasterInventory({
        data,
      });
      setSearchData(result.data.content);
      setCurrentPage(result.data.number);
      setTotalPages(result.data.totalPages);
      setTotalElements(result.data.totalElements);
      setSize(result.data.size);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      console.log(err);
    }
  };

  const handleGohonzonTypeChange = (event) => {
    setSelectedGohonzonType(event.target.value);
  };

  const handleTransactionTypeChange = (event) => {
    setSelectedTransactionType(event.target.value);
  };

  const onPaginationClick = (page) => {
    fetchData(Number(page), size);
  };

  const onPageSizeClick = (operator) => {
    const newPageSize = performOperation(
      size,
      Constants.DEFAULT_PAGE_SIZE,
      operator
    );
    fetchData(0, newPageSize);
  };

  const handleClearGohonzonType = () => {
    setSelectedGohonzonType("");
  };

  const handleClearGohonzonTransactionType = () => {
    setSelectedTransactionType("");
  };

  const onSubmit = (e) => {
    e.preventDefault();
    fetchData();
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <Box sx={style.container}>
      <form onSubmit={onSubmit}>
        <Box style={{ ...style.search, justtifyContent: "space-between" }}>
          <Box width="40%">
            <Dropdown
              value={selectedGohonzonType}
              options={GOHONZON_OPTIONS}
              label="Gohonzon Type"
              onChange={handleGohonzonTypeChange}
              showCross
              handleClearValue={handleClearGohonzonType}
            />
          </Box>
          <Box width="40%">
            <Dropdown
              value={selectedTransactionType}
              options={GOHONZON_TRANSACTION_TYPE_OPTIONS}
              label="Gohonzon Transaction Type"
              onChange={handleTransactionTypeChange}
              showCross
              handleClearValue={handleClearGohonzonTransactionType}
            />
          </Box>
          <Button label="Search" type="submit" />
        </Box>
      </form>
      <Box style={style.tableContainer}>
        <Box style={style.tableHeading}>
          <Box style={style.tableTitle}>Gohonzon Handover</Box>
        </Box>
        {searchData?.length ? (
          <>
            <Table
              scrollable
              columns={GOHONZON_HANDOVER_INVENTORY_COL}
              rows={getRows(searchData)}
              columnCellStyle={{ textAlign: "left" }}
              tableBodyTheme="#F6F6F6"
              tableHeadCellStyle={{
                ...style.tableHeadCells,
                // textAlign: "left",
              }}
            />
            <Box style={style.pagination}>
              <Pagination
                totalPages={totalPages}
                totalResults={totalElements}
                currentPage={currentPage}
                pageSize={size}
                onChange={onPaginationClick}
                onPageSizeClick={onPageSizeClick}
              />
            </Box>
          </>
        ) : (
          <Box style={style.emptyContainer}>
            <h1 style={style.noDataMsg}>No Results</h1>
          </Box>
        )}
      </Box>
      {isLoading && <Loader />}
      <Toast
        open={!!showToast}
        severity={showToast?.severity || ""}
        message={showToast?.message || ""}
        handleClose={() => {
          setShowToast(null);
        }}
      />
    </Box>
  );
}

export default HandoverInventory;
